import { useForm } from "react-hook-form";
import { AnswerInput } from "../AnswerInput";
import { MultipleAnswerInput } from "../MultipleAnswerInput";
import { useEffect, useRef } from "react";
import { getStep4Data } from "../../helper";
import { Chip } from "../Chip";
import { CollapsibleCard } from "../Accordian";
import { TaskCard } from "../TaskCard";

export const getBadge = () => {
  return (
    <div className="d-flex flex-row gap-2">
      <div
        className="d-flex justify-content-center align-items-center rounded-pill px-3"
        style={{
          backgroundColor: "#008CFF", // A default blue-ish background for badges
          color: "#fff",
          fontSize: "14px",
          height: "22px",
        }}
      >
        Mit List
      </div>

      <div
        className="d-flex justify-content-center align-items-center rounded-pill px-3"
        style={{
          backgroundColor: "#008CFF", // A default blue-ish background for badges
          color: "#fff",
          fontSize: "14px",
          height: "22px",
        }}
      >
        Do List
      </div>
    </div>
  );
};

export const Step4 = ({
  questions = [],
  answers = {},
  updateAnswer,
  warmapQuestionResponse = {},
}) => {
  const step4Data = getStep4Data(warmapQuestionResponse);

  const defaultValues = questions.reduce((acc, question) => {
    if (!question.allow_multiple_answers) {
      acc[String(question.id)] =
        answers[question.id] || question?.answer?.answer_text || "";
    }
    return acc;
  }, {});

  const { control, setValue } = useForm({
    defaultValues,
  });

  const prevAnswersRef = useRef(answers);

  useEffect(() => {
    questions.forEach((question) => {
      if (!question.allow_multiple_answers) {
        const questionId = String(question.id);
        const currentAnswer = answers[question.id];
        const prevAnswer = prevAnswersRef.current[question.id];

        if (currentAnswer !== prevAnswer && currentAnswer !== undefined) {
          setValue(questionId, currentAnswer, { shouldDirty: false });
        }
      }
    });

    prevAnswersRef.current = { ...answers };
  }, [answers, questions, setValue]);

  return (
    <div className="d-flex flex-column w-full" style={{ gap: "24px" }}>
      <div className="d-flex flex-row justify-content-center align-items-center w-full gap-3">
        <Chip
          label="MIT’s Achieved"
          content={`${step4Data.totalMitAchieve} / ${step4Data.totalMitTasks}`}
        />
        <Chip label="Do List Done" content={`${step4Data.totalDoListDone}`} />
      </div>

      <div>
        <CollapsibleCard
          title="My MIT and DO List Tasks This Week"
          defaultOpen={true}
          defaultBadge={getBadge()}
        >
          <TaskCard tasks={step4Data.tasks} />
        </CollapsibleCard>
      </div>

      {questions?.length > 0 &&
        questions.map((question) => {
          if (question.allow_multiple_answers) {
            return (
              <MultipleAnswerInput
                key={question.id}
                questionId={question.id}
                label={question.question_text}
                defaultValue={
                  answers[question.id] || question?.answer?.answer_text || ""
                }
                onValueChange={(value) => {
                  if (updateAnswer) {
                    updateAnswer(question.id, value);
                  }
                }}
              />
            );
          }

          return (
            <AnswerInput
              control={control}
              key={question.id}
              name={String(question.id)}
              label={question.question_text}
              defaultValue={
                answers[question.id] || question?.answer?.answer_text || ""
              }
              onValueChange={(value) => {
                if (updateAnswer) {
                  updateAnswer(question.id, value);
                }
              }}
            />
          );
        })}
    </div>
  );
};
